import { assertNever } from '@spiaggeit/spit-core'
import { Button, Dialog } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'
import { SectorRuleError } from '@/models/http'

type Props = {
  isOpen: boolean
  sectorRuleError:
    | SectorRuleError.INVALID_END_DATE
    | SectorRuleError.TOO_MANY_RESERVATIONS
    | null

  onConfirm: () => void
  setIsOpen: (isOpen: boolean) => void
}

export function PreemptionCodeErrorDialog(props: Props) {
  const { t } = useTranslation()

  if (props.sectorRuleError === null) {
    return null
  }

  let dialogTitle = ''

  switch (props.sectorRuleError) {
    case SectorRuleError.INVALID_END_DATE:
      dialogTitle = t('preemptionCode.errorDialog.invalidEndDate.title')
      break
    case SectorRuleError.TOO_MANY_RESERVATIONS:
      dialogTitle = t('preemptionCode.errorDialog.maxReservationsPerCode.title')
      break
    default:
      assertNever(props.sectorRuleError)
  }

  return (
    <Dialog
      isOpen={props.isOpen}
      mobileMode="bottomSheet"
      setIsOpen={props.setIsOpen}
      size="sm"
      title={dialogTitle}
      trigger={null}
    >
      <div className="p-4">
        <p className="mb-6">{t('preemptionCode.errorDialog.message')}</p>
        <Button className="mb-2" fullWidth onClick={() => props.onConfirm()}>
          {t('preemptionCode.errorDialog.confirmBtn')}
        </Button>
        <Button
          fullWidth
          onClick={() => props.setIsOpen(false)}
          variant="outline"
        >
          {t('preemptionCode.errorDialog.closeBtn')}
        </Button>
      </div>
    </Dialog>
  )
}
